import React, { useState, useEffect } from 'react';
import axios from "axios";
import jungjinlog from  '../img/coup/220130_Jcoup_logo-03.png';
import { useStoresIpgo } from '../UseStores/UseStore';
import moment from "moment";



function IpgoPrintBox(props) {
  const [imgview, setImgview] = useState([]);

  const { ipgoprintopentrue,ipgoprintopenhangmok } = useStoresIpgo();
  //console.log(ipgoprintopenhangmok)
  const view = ipgoprintopenhangmok.ipgo_item ? ipgoprintopenhangmok.ipgo_item : props.ipgoprintmove.ipgo_item ;
  //console.log(`두번째: ${view}` )

  useEffect(() => {
    const imgJsonLoad = async () => {
      await axios.get(`/IpgoReact/ItemImgIndex?ItemSabun=${view}`)
              .then((res) => {
                //setImgview(res.date);
                //console.log(res.data)
                setImgview(res.data[0].file);
              })
      };
    imgJsonLoad()
  },[view]);

  return (
    <div>
      <div className="content">
        {/*우리품번바코드*/}
        <div className="printbarcodesabun">
          {ipgoprintopentrue === true
            ? `*${ipgoprintopenhangmok.ipgo_item_auto}*`
            : `*${props.ipgoprintmove.ipgo_item_auto}*`}
        </div>
        <div>
          <img
            className="imgsabun"
            src={`data:image/png;base64,${imgview}`}
            alt="에라"
          />
        </div>
        <div>
          <img className="printjungjinlog" src={jungjinlog} alt="제이콥로그" />
          <div className="printgongjung">도포공정이동전표</div>
        </div>
        <table className="printtable">
          <thead></thead>
          <tbody>
            <tr>
              <td colSpan='6' className="printtd-02">
                1.작업이력현황
              </td>
            </tr>
            <tr>
              <td className="printtd-00 print--00 printfont">
                지시번호
              </td>
              <td className="printtd-01 print--00 printfont">
                {ipgoprintopentrue === true
                  ? ipgoprintopenhangmok.ipgo_item_auto
                  : props.ipgoprintmove.ipgo_item_auto}
              </td>
              <td className="printtd-00 print--00">우리품번</td>
              <td colSpan='3' className="printtd-01 print--00">
                {ipgoprintopentrue === true
                  ? ipgoprintopenhangmok.ipgo_item
                  : props.ipgoprintmove.ipgo_item}
              </td>
            </tr>
            <tr>
              <td className="printtd-00 print--00">제품별명</td>
              <td className="printtd-01 print--00">
                {ipgoprintopentrue === true
                  ? ipgoprintopenhangmok.ipgo_item_bel_meng
                  : props.ipgoprintmove.ipgo_item_bel_meng}
              </td>
              <td className="printtd-00 print--00 printfont" >품번</td>
              <td colSpan='3' className="printtd-01 print--00 printfont">
                {ipgoprintopentrue === true
                  ? ipgoprintopenhangmok.ipgo_item_upche_item
                  : props.ipgoprintmove.ipgo_item_upche_item}
              </td>
            </tr>
            <tr>
              <td className="printtd-00 print--00">품명</td>
              <td className="printtd-01 print--00">
                {ipgoprintopentrue === true
                  ? ipgoprintopenhangmok.ipgo_item_upche_name
                  : props.ipgoprintmove.ipgo_item_upche_name}
              </td>
              <td className="printtd-00 print--00">업체명</td>
              <td colSpan='3' className="printtd-01 print--00">
                {ipgoprintopentrue === true
                  ? ipgoprintopenhangmok.ipgo_item_upche_sangho
                  : props.ipgoprintmove.ipgo_item_upche_sangho}
              </td>
            </tr>
            <tr>
              <td className="printtd-00 print--00">입고일자</td>
              <td className="printtd-01 print--00">
                {ipgoprintopentrue === true
                  ? moment(ipgoprintopenhangmok.ipgo_item_datetime).format(
                      "YYYYMMDD HH:mm"
                    )
                  : moment(props.ipgoprintmove.ipgo_item_datetime).format(
                      "YYYYMMDD HH:mm"
                    )}
              </td>
              <td className="printtd-00 print--00">입고수량</td>
              <td className="printtd-01 print--00 printfont">
                {ipgoprintopentrue === true
                ? ipgoprintopenhangmok.ipgo_item_quantity +
                  ipgoprintopenhangmok.ipgo_item_daewi
                : props.ipgoprintmove.ipgo_item_quantity +
                  props.ipgoprintmove.ipgo_item_daewi}
              </td>
              <td className="printtd-00 print--00">용기수량</td>
              <td className="printtd-01 print--00">
                {ipgoprintopentrue === true
                  ? ipgoprintopenhangmok.ipgo_dangrang
                  : props.ipgoprintmove.ipgo_dangrang}
              </td>
            </tr>
            <tr>
              <td className="printtd-00 print--00">작업라인</td>
              <td className="printtd-01 print--00">
                {ipgoprintopentrue === true
                  ? ipgoprintopenhangmok.ipgo_item_cheri_desc
                  : props.ipgoprintmove.ipgo_item_cheri_desc}
              </td>
              <td className="printtd-00 print--00">작업공정</td>
              <td colSpan='3' className="printtd-01 print--00">
                {ipgoprintopentrue === true
                  ? ipgoprintopenhangmok.ipgo_최종공정라인
                  : props.ipgoprintmove.ipgo_최종공정라인}
              </td>
            </tr>
            <tr>
              <td className="printtd-00 print--00">업체전표량</td>
              <td className="printtd-01 print--00">
                {ipgoprintopentrue === true
                  ? ipgoprintopenhangmok.ipgo_ticket_jundal
                  : props.ipgoprintmove.ipgo_ticket_jundal}
              </td>
              <td className="printtd-00 print--00">기타사항</td>
              <td colSpan='3' className="printtd-01 print--00">
                {ipgoprintopentrue === true
                  ? ipgoprintopenhangmok.ipgo_item_description
                  : props.ipgoprintmove.ipgo_item_description}
              </td>
            </tr>
            <tr>
              <td className="printtd-00 print--00">작업요청일</td>
              <td className="printtd-01 print--00"></td>
              <td className="printtd-00 print--00">업체LOT</td>
              <td colSpan='3' className="printtd-01 print--00">
                {ipgoprintopentrue === true
                  ? ipgoprintopenhangmok.ipgo_upche_lot_code
                  : props.ipgoprintmove.ipgo_upche_lot_code}
              </td>
            </tr>
          </tbody>
        </table>
        <div style={{ textAlign: "right", fontSize: "18px", color:'blue' }}>
          해당 작업지시번호 도포작업완료[프린트후 사무실]         
        </div>
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />

        <hr className="lineJulche"></hr>

        <br />
        <br />
        <br />
        <table className="printtable01 ">
          <tbody>
            <tr>
              <td colSpan="2" className="printbarcodesabun01">
                {ipgoprintopentrue === true
                  ? `*${ipgoprintopenhangmok.ipgo_item_auto}*`
                  : `*${props.ipgoprintmove.ipgo_item_auto}*`}
              </td>
            </tr>
            <tr>
              <td colSpan="2" className="printtd-04 print--001">
                공장간 이동전표
              </td>
            </tr>
            <tr>
              <td colSpan="2" className="print--002">
                정진1공장 --&gt; 제이콥2공장{" "}
              </td>
            </tr>
            <tr>
              <td className="printtd-04 print--01 ">업체</td>
              <td className="print--01 ">
                {ipgoprintopentrue === true
                  ? ipgoprintopenhangmok.ipgo_item_upche_sangho
                  : props.ipgoprintmove.ipgo_item_upche_sangho}
              </td>
            </tr>
            <tr>
              <td className="printtd-04 print--01 ">지시번호</td>
              <td className="print--01 ">
                {ipgoprintopentrue === true
                  ? ipgoprintopenhangmok.ipgo_item_auto
                  : props.ipgoprintmove.ipgo_item_auto}{" "}
              </td>
            </tr>
            <tr>
              <td className="printtd-04 print--01 ">업체품번</td>
              <td className="print--01 printfont ">
                {ipgoprintopentrue === true
                  ? ipgoprintopenhangmok.ipgo_item_upche_item
                  : props.ipgoprintmove.ipgo_item_upche_item}
              </td>
            </tr>
            <tr>
              <td className="printtd-04 print--01 ">우리품번</td>
              <td className="print--01 printfont ">
                {ipgoprintopentrue === true
                  ? ipgoprintopenhangmok.ipgo_item
                  : props.ipgoprintmove.ipgo_item}{" "}
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                입고수량:
                {ipgoprintopentrue === true
                  ? ipgoprintopenhangmok.ipgo_item_quantity
                  : props.ipgoprintmove.ipgo_item_quantity}
                {ipgoprintopentrue === true
                  ? ipgoprintopenhangmok.ipgo_item_do_danwie
                  : props.ipgoprintmove.ipgo_item_do_danwie}
              </td>
            </tr>
            <tr>
              <td className="printtd-04 print--01 ">입고일자</td>
              <td className="print--01 ">
                {ipgoprintopentrue === true
                  ? moment(ipgoprintopenhangmok.ipgo_item_datetime).format(
                      "YYYYMMDD HH:mm"
                    )
                  : moment(props.ipgoprintmove.ipgo_item_datetime).format(
                      "YYYYMMDD HH:mm"
                    )}
              </td>
            </tr>
            <tr>
              <td className="printtd-04 print--01 ">인계자</td>
              <td style={{ color: "#d3d3d3" }} className="print--01 ">
                이름을 기록하세요
              </td>
            </tr>
          </tbody>
        </table>
        <div style={{ textAlign: "right", fontSize: "20px" }}>
          1공장바코드 찍고 --&gt; 2공장에서 바코드 찍어세요
        </div>
      </div>
    </div>
  );
}

export default IpgoPrintBox